'use strict';

/* globals define, document */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/conferences/create-conference', [
	'translator',
	'benchpress',
	'slugify'
], function (translator, Benchpress, slugify) {
	var	CreateConference = {};

	CreateConference.init = function () {
		ajaxify.data.availableUsers.forEach(function (user) {
			addUserToList(user);
		});

		$('[data-action="create-conference"]').click(createConference);
	};

	function addUserToList (user) {
		var availableUsers = $('#available-users');

		Benchpress.parse('partials/conferences/available-user', { user: user, }, function (html) {
			availableUsers.append(html);

			$('[data-action="add-to-conference"][data-uid="' + user.uid + '"]').click(function () {
				removeUserFromList(this);
				addUserToConference(getUser($(this).attr('data-uid')));
			});
		});
	}

	function removeUserFromList (btnEl) {
		$(btnEl).closest('.available-user').remove();
	}

	function addUserToConference(user) {
		var conferenceUsers = $('#conference-users');
		
		Benchpress.parse('partials/conferences/conference-user', { user: user, }, function (html) {
			conferenceUsers.append(html);

			$('[data-action="remove-from-conference"][data-uid="' + user.uid + '"]').click(function () {
				removeUserFromConference(this);
				addUserToList(getUser($(this).attr('data-uid')));
			});
		});
	}

	function removeUserFromConference(btnEl) {
		$(btnEl).closest('.conference-user').remove();
	}

	function getUser(uid) {
		return ajaxify.data.availableUsers.find(function (user) {
			return user.uid == uid;
		});
	}

	function createConference() {
		var conference = {
			title: $('#title').val(),
			users: getConferenceUsers()
		};

		if (!conference.title.trim().length) {
			app.alertError('[[conferences:conference-name-required]]');

			return false;
		}

		socket.emit('plugins.conferences.createConference', conference, function (err, conferenceId) {
			if (err) {
				return app.alertError(err.message);
			}

			app.alert({
				alert_id: 'created_conference',
				message: '[[conferences:conference-created-message]]',
				type: 'success',
				timeout: 2000,
			});

			ajaxify.go('conferences/room/' + conferenceId + '/' + slugify(conference.title));
		});
	}

	function getConferenceUsers() {
		return $.map($('.conference-user'), function(userEl) {
			return $(userEl).attr('data-uid');
		});
	}

	return CreateConference;
});
